<template>
  <div :class="class">
    <label
      :for="`date-picker-${inputName}`"
      class="text-sm font-medium text-gray-700 mb-1"
    >
      {{ title }}
    </label>

    <div class="flex items-center">
      <VueDatePicker
        v-model="dateDirty"
        :id="`date-picker-${inputName}-dirty`"
        :name="`${inputName}-dirty`"
        :range="false"
        :class="[
          'h-full focus:outline-none focus:ring-2 focus:ring-blue-500 max-w-xl',
          { 'ring-2 ring-blue-500': isFocused },
        ]"
        @focus="isFocused = true"
        @blur="isFocused = false"
        format="yyyy/MM/dd HH:mm"
        placeholder="yyyy/mm/dd hh:mm"
        :enable-time-picker="true"
        teleport="body"
        :z-index="9999"
      />
      <input type="hidden" :name="inputName" :value="cleanValue" />
    </div>
  </div>
</template>

<script>
import { IconSearch } from "@tabler/icons-vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

export default {
  name: "DateTimePicker",
  props: {
    title: {
      type: String,
      required: true,
    },
    inputName: {
      type: String,
      required: true,
    },
    class: {
      type: String,
      default: "",
    },
  },
  components: { VueDatePicker, IconSearch },
  data() {
    return {
      dateDirty: null,
      isFocused: false,
    };
  },
  created() {},
  computed: {
    cleanValue() {
      if (!this.dateDirty) return;

      const formattedDate = new Date(
        String(this.dateDirty).replace(
          /(\d{4})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2})/,
          "$1-$2-$3T$4:$5:00"
        )
      );

      return formattedDate.toISOString();
    },
  },
  watch: {
    dateDirty(newVal) {
      if (newVal) {
        localStorage.setItem(this.inputName, newVal);
      } else {
        localStorage.removeItem(this.inputName);
      }
    },
  },
  mounted() {
    const storedDate = localStorage.getItem(this.inputName);
    if (storedDate) {
      this.dateDirty = storedDate;
    }
  },
};
</script>
